$(window).bind("pageshow", function() {
  if ($(".filters-component").length) {
    $(".basic-checkbox").each(function() {
      $(this).prop("checked", true)
    })
  }
});



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/references-filter-updater.js